import React from 'react'
import css from './style.scss'
import {FullPage} from 'components/container';
import api from './api';
import store from 'utils/store'
import {push} from 'react-router-redux'
import Formsy from 'formsy-react-2';
import Input from 'components/shared/input'
import Button from 'components/shared/button'
import Loading from 'components/shared/loading'


class ResetPage extends React.Component{
  constructor(props){
    super(props)
    this.state={
      status:"",
      loading:true,
      token:""
    }
  }
  componentDidMount(){
    let token=window.location.href.split("/").pop()
    this.setState({token})
    api.checkToken(token).then(e=>{
      if(e){
        this.setState({loading:false})
      }else{
        store.dispatch({type:"ADD_TOAST", message:"Token not valid or expired."})
      }
    })
  }
  submit=(model)=>{
    this.setState({status:"loading"})
    api.resetPassword(this.state.token, model.password).then(()=>{
      this.setState({status:"done"})
      store.dispatch({type:"ADD_TOAST", message:"Reset password successfull!"})
      setTimeout(()=>{
        store.dispatch(push("/login"))
      },1000)
    })
  }

  render(){
    return (
      <FullPage withPadding withContainer dotted>
        <div>
          {this.state.loading && <Loading/>}
          {!this.state.loading &&
            <div className={css.loginContainer}>
              <div className={css.login}>
                <h4>Reset your password</h4>
                <Formsy.Form onValidSubmit={this.submit}>
                  <Input type="password" fullWidth={true} required label="Your new password" name="password"/>
                  <Button primary type="submit">Reset Password</Button>
                </Formsy.Form>
              </div>
            </div>
          }
        </div>
      </FullPage>
    )
  }
}


export default ResetPage;



// WEBPACK FOOTER //
// ./src/components/password/reset.js